// Import model
import { Fcb2BProductTypeOption } from '../models/Fcb2BProductTypeOption';

// Import base class serializer
import { EstimateOptionsSerializer } from './EstimateOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Fcb2BProductTypeOption - handles JSON serialization and deserialization with type validation
 */
export class Fcb2BProductTypeOptionSerializer {
  /**
   * Deserializes a JSON string into a Fcb2BProductTypeOption instance
   */
  static deserialize(json: string): Fcb2BProductTypeOption {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Fcb2BProductTypeOption instance
   */
  static fromObject(obj: any): Fcb2BProductTypeOption {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Fcb2BProductTypeOption');
    }


    const instance: Fcb2BProductTypeOption = {
      description: obj['description'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      name: obj['name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      type_: obj['type'] as string,
      code: obj['code'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Fcb2BProductTypeOption instances
   */
  static deserializeArray(json: string): Fcb2BProductTypeOption[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Fcb2BProductTypeOption instance to a JSON string
   */
  static serialize(instance: Fcb2BProductTypeOption): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Fcb2BProductTypeOption instance to a plain object
   */
  static toObject(instance: Fcb2BProductTypeOption): any {
    return {
      'description': instance.description,
      'externalId': instance.externalId,
      'name': instance.name,
      '_id': instance.id,
      'type': instance.type_,
      'code': instance.code,
    };
  }

  /**
   * Serializes an array of Fcb2BProductTypeOption instances to a JSON string
   */
  static serializeArray(instances: Fcb2BProductTypeOption[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
